'use strict';

angular.module('amexReconciliationApp')
  .directive('formatCurrency',
  function currency($filter, UserModel) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elm, attrs, ngModel) {
        ngModel.$formatters.push(function (value) {
          return $filter('userPreferenceCurrencyFormat')(value, UserModel.getCurrencyFormat());
        });

        elm.bind('blur', function() {
          var viewValue = ngModel.$modelValue;
          if (_.isNumber(+viewValue) && isFinite(viewValue) && !_.isNaN(+viewValue)) {
            var formatters = _.clone(ngModel.$formatters).reverse();

            _.forEach(formatters, function(formatter){
              viewValue = formatter(viewValue);
            });

            ngModel.$viewValue = viewValue;
            ngModel.$render();
          }
        });
      }
    };
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/directives/formatCurrency.js
// module id = 523
// module chunks = 0